export default __webpack_public_path__ + "static/media/shopping-cart-solid.d112c497.svg";